$(document).ready(function () {
    var mainNavIsClosed = true;
    var chapterNavIsClosed = true;
    // var pageNavIsClosed = true;
    var searchBarIsClosed = true;
    // Match breadcrumb timing: activate when section top reaches 10px from viewport top.
    var pageNavActivationOffsetPx = 90;
    var pageNavActiveTriggers = [];
    var pageNavScrollTriggerThreshold = -pageNavActivationOffsetPx;
    var topBarLeft = $('.topbar--left');
    var topBar = document.querySelector('.topbar');
    var chapterSlider;

    colorMainNavLink();
    chapterNavSlider();
    init();

    barba.use(barbaPrefetch);

    barba.init({
        timeout: 10000,
        //debug: true,
        preventRunning: true,
        transitions: [{
            name: 'switch',
            once({ current, next, trigger }) {
                // isOnce = true;

                // var pageColor = $(next.container).data('bg');
                // var textColor = $(next.container).data('text-color');
                // var nextPageTitle = $(next.container).data('logo-title');

                // gsap.set($('body'), { backgroundColor: pageColor, '--current-bg-color': pageColor, color: textColor, '--current-txt-color': textColor });
                // gsap.to(document.querySelector('meta[name="theme-color"]'), { duration: .5, attr: { content: pageColor }, ease: Expo.easeInOut });


                // $('.topbar__page-name span').html(nextPageTitle);

                // $('body').addClass(next.namespace);

                setTimeout(function () {
                    $(window).trigger('resize');
                    ScrollTrigger.refresh();
                }, 500);

                // var font = new FontFaceObserver("Baikal");

                // font.load(null, 5000).then(function () {
                //     
                //     gsap.to('.curtain', {autoAlpha: 0, duration: .3, delay: .5, onComplete: function(){$('.curtain').remove()}})
                // }, function () {
                //     
                //     gsap.to('.curtain', {autoAlpha: 0, duration: .3, delay: .5, onComplete: function(){$('.curtain').remove()}})
                // });

            },
            leave({ current, next, trigger }) {

                return new Promise(resolve => {
                    const leavingAnim = gsap.timeline({
                        onComplete() {
                            resolve();
                        }
                    });

                    leavingAnim.to(current.container, .5, { autoAlpha: 0, display: 'none', ease: Expo.easeInOut });
                });
            },
            beforeLeave({ current, next, trigger }) {
                toggleMainNav('close');
                toggleChapterNav('close');
                // togglePageNav('close');
                toggleSearchBar('close');
                
            },
            beforeEnter({ current, next, trigger }) {
                
                window.scrollTo(0, 0);

                // gsap.to($('.topbar--page-nav'), { autoAlpha: 0 });
                killAllScrollTrigger();

                // isOnce = false;
                init();
            },
            enter({ current, next, trigger }) {

                // var pageColor = $(next.container).data('bg');
                // var textColor = $(next.container).data('text-color');
                // var nextPageTitle = $(next.container).data('logo-title');

                // gsap.set($('body'), { backgroundColor: pageColor, '--current-bg-color': pageColor, color: textColor, '--current-txt-color': textColor });
                // gsap.to(document.querySelector('meta[name="theme-color"]'), { duration: .5, attr: { content: pageColor }, ease: Expo.easeInOut });

                // $('.topbar__page-name span').html(nextPageTitle);

                // if (next.url.hash != undefined) {
                //     var isSpecialPage = next.namespace == 'page-special';

                //     var offset = isSpecialPage ? $('.topbar').outerHeight() + 80 : 0;
                //     //var offset = $('.topbar').outerHeight() + 80;
                //     gsap.to(window, { duration: 1, scrollTo: { y: '#' + next.url.hash, offsetY: offset }, ease: Power4.easeInOut });
                // };



                // currentPageType = next.namespace;
                // 
                // $('body').addClass(next.namespace);
                $(next.container).imagesLoaded( function() {
                    // images have loaded
                    gsap.to(window, { duration: 1, scrollTo: { y: '#' + next.url.hash }, ease: Power4.easeInOut });
                });
                

                preventSamePageReload();

                return new Promise(resolve => {

                    const enterAnim = gsap.timeline({
                        onComplete() {
                            resolve();
                        }
                    });

                    enterAnim.fromTo(next.container, .5, { autoAlpha: 0 }, { autoAlpha: 1, ease: Expo.easeInOut });
                });
            },
            afterEnter({ current, next, trigger }) {
                
                $nextScrollTo = $(next.container).find('.scroll-to');
                $nextHeader = $(next.container).find('.header');

                if ($nextScrollTo.length) {
                    hideScrollTo($nextScrollTo, $nextHeader);
                }
                
                $(window).trigger('resize');

            }
        }],
        views: [{
            namespace: 'home',
            beforeEnter() {
                var breadcrumb = topBarLeft.find('.breadcrumb');

                if (breadcrumb.length) {
                    gsap.to(breadcrumb, {
                        autoAlpha: 0, onComplete: function () {
                            breadcrumb.remove();
                        }
                    });
                }
            },
            afterEnter({ current, next, trigger }) {

                // var categories = $(next.html).find('.category');
                // var catArray = [];

                // categories.each(function (e) {
                //     catArray.push($(this).attr('id'))
                // });

                // var pageNavTemplate = `
                // <ul class="page-nav">
                //     ${catArray.map((item, i) => {
                //     return `<li class="page-nav__item"><a href="#${item}" class="page-nav__link" title="${item}">${item}</a></li>`

                // }).join('')
                //     }
                // </ul>
                // `;

                // pageNav.prepend(pageNavTemplate);

                // gsap.to($('.topbar--page-nav'), {
                //     autoAlpha: 1, onComplete: function () {
                //         Draggable.create($(pageNav).find('.page-nav'), { type: 'x', edgeResistance: 0.65, bounds: $(pageNav) });
                //         // Draggable.create($(mobilePageNav).find('.page-nav'), { type: 'x', edgeResistance: 0.65, bounds: $(mobilePageNav) });
                //         activePageNav($('.category[id]'))//$('.article .block[id]')
                //     }
                // });



            }
        },
        {
            namespace: 'chapter',
            beforeEnter() {
                var breadcrumb = topBarLeft.find('.breadcrumb');

                if (breadcrumb.length) {
                    gsap.to(breadcrumb, {
                        autoAlpha: 0, onComplete: function () {
                            breadcrumb.remove();
                        }
                    });
                };


            },
            afterEnter({ current, next, trigger }) {

                var nextUrl = next.url.path;
                
                var chapterName = $(next.container).data('chapter');
                

                var breadcrumbTemplate = `
                    <div class="breadcrumb">
                        <span class="breadcrumb__page-name">${chapterName}</span>
                        <span class="breadcrumb__section-name">
                            <span></span>
                        </span>
                    </div>
                `;

                topBarLeft.append(breadcrumbTemplate);
                gsap.fromTo(topBarLeft.find('.breadcrumb'), { autoAlpha: 0, duration: .5 }, { autoAlpha: 1, onComplete: function(){
                    setTimeout(function() {
                        pageNav();
                    }, 100);
                } });
                
                var currentItem = $('.chapter-nav__link[href*="' + nextUrl + '"]').parent('.chapter-nav__item');
                var currentItemIndex = currentItem.index();
                
                $('.chapter-nav__item').removeClass('chapter-nav__item--current');
                currentItem.addClass('chapter-nav__item--current');
                chapterSlider.slideTo(currentItemIndex - 1, 0);

            },
        },
        // {
        //     namespace: 'downloads',
        //     beforeEnter() {
        //         var breadcrumb = topBarLeft.find('.breadcrumb');

        //         if (breadcrumb.length) {
        //             gsap.to(breadcrumb, {
        //                 autoAlpha: 0, onComplete: function () {
        //                     breadcrumb.remove();
        //                 }
        //             });
        //         };


        //     },
        //     afterEnter({ current, next, trigger }) {

        //         var nextUrl = next.url.path;
        //         var chapterName = $(next.container).data('page');

        //         var breadcrumbTemplate = `
        //             <div class="breadcrumb">
        //                 <span class="breadcrumb__page-name">${chapterName}</span>
        //                 <span class="breadcrumb__section-name">
        //                     <span></span>
        //                 </span>
        //             </div>
        //         `;

        //         topBarLeft.append(breadcrumbTemplate);
        //         gsap.fromTo(topBarLeft.find('.breadcrumb'), { autoAlpha: 0, duration: .5 }, { autoAlpha: 1 });

        //         $('.chapter-nav__item').removeClass('chapter-nav__item--current');
        //         chapterSlider.slideTo(0, 0);

        //         pageNav();

        //     },
        // }

        ]
    },

    );

    $('.main-nav-trigger').on('click', function (e) {
        if (mainNavIsClosed) {
            toggleMainNav('open');

            if (!chapterNavIsClosed) {
                toggleChapterNav('close');
            }

            // if (!pageNavIsClosed) {
            //     togglePageNav('close');
            // }

            if (!searchBarIsClosed) {
                toggleSearchBar('close');
            }

        } else {
            toggleMainNav('close');
        };


    });

    $('.chapter-nav-trigger').on('click', function (e) {
        if (chapterNavIsClosed) {
            toggleChapterNav('open');

            if (!mainNavIsClosed) {
                toggleMainNav('close');
            }

            // if (!pageNavIsClosed) {
            //     togglePageNav('close');
            // }

            if (!searchBarIsClosed) {
                toggleSearchBar('close');
            }

        } else {
            toggleChapterNav('close');
        }

    });

    $('.search-trigger').on('click', function (e) {
        if (searchBarIsClosed) {
            $('.search-bar__input').trigger('focus');
            toggleSearchBar('open');


            if (!chapterNavIsClosed) {
                toggleChapterNav('close');
            }

            if (!mainNavIsClosed) {
                toggleMainNav('close');
            }

            // if (!pageNavIsClosed) {
            //     togglePageNav('close');
            // }

        } else {
            $('.search-bar__input').trigger('blur');
            toggleSearchBar('close');
        }

    });

    $('.search-bar__input').on('keyup focus', function(){
        var thisVal = ($(this).val()).toLowerCase();
        var $results = $('.search-bar__results');

        $(this).parent('.search-bar__input-wrapper').addClass('search-bar__input-wrapper--is-focus');

        if(thisVal.length > 2){
            fetch(thisVal);
            //$('.search-bar__sentence').show();
            $('.search-bar__keyword').html(thisVal);
        } else {
            $results.find('ul').empty();
            $results.hide();
            $('.search-bar__sentence').hide();
        }
    });

    $('.search-bar__input').on('blur', function(){
        $(this).parent('.search-bar__input-wrapper').removeClass('search-bar__input-wrapper--is-focus');
    });

    // $('.search-events__input').on('blur', function(){
    //     var thisResultWrapper = $(this).parents('.search-events').find('.search-events__results');
    //     setTimeout(function(){
    //         thisResultWrapper.empty().hide();
    //     }, 500);
        

    // });

    function init() {
        
        masonry();
        plyrVid();
        dropdowns();
        scrollToHeader();
        hideScrollTo( $('.scroll-to'), $('.header'));
        pageNav();
        // $('.page-nav-trigger').on('click', function (e) {
        //
        //     if (pageNavIsClosed) {
        //         togglePageNav('open');
        //
        //         if (!mainNavIsClosed) {
        //             toggleMainNav('close');
        //         };
        //
        //         if (!chapterNavIsClosed) {
        //             toggleChapterNav('close');
        //         };
        //
        //     } else {
        //         togglePageNav('close');
        //     }
        // });

        $('.main').imagesLoaded(function () {
            $(window).trigger('resize');
            ScrollTrigger.refresh();
        });

        slidersImg();

        $('.pin__button').on('click', function(){
            $(this).parent('.pin').toggleClass('pin--is-closed');
        });
    };

    function killAllScrollTrigger() {

        let triggers = ScrollTrigger.getAll();
        triggers.forEach(trigger => {
            trigger.kill();
        });

    };

    function preventSamePageReload() {
        var links = document.querySelectorAll('a[href]');
        var cbk = function (e) {
            if (e.currentTarget.href === window.location.href) {
                e.preventDefault();
                e.stopPropagation();

                // if (!navIsClosed) {
                //     closeNavTl.play();
                // }
            }
        };

        for (var i = 0; i < links.length; i++) {
            links[i].addEventListener('click', cbk);
        }
    };

    function debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    function fetch(val){
        var baseUrl = window.location.origin;
        
        // $.getJSON( baseUrl + '/wp-json/wp/v2/chapters' + '?_embed', function( data ) {
        $.getJSON( baseUrl + '/wp-json/wp/v2/chapters?per_page=100&_embed', function( data ) {
            
            var chapters = [];
            data.forEach(function(chapter){
                
                //
                //
                var chapterTitle = chapter.title.rendered.toLowerCase();
                var sections = chapter.acf.section;
                //
                    if(chapterTitle.includes(val)){
                        var theChapter = {};

                        theChapter.title = chapter.title.rendered;
                        theChapter.permalink = chapter.link;
                        theChapter.imgUrl = chapter._embedded['wp:featuredmedia'][0]['source_url'];
                        
                        chapters.push(theChapter);
                    }
                    if(sections!= null){
                        sections.forEach(function(section){
                            var sectionTitle = section.title.toLowerCase();
                            var modules = section.modules;
                            //

                            if(sectionTitle.includes(val)){
                                var theChapter = {};
        
                                theChapter.title = chapter.title.rendered;
                                theChapter.permalink = chapter.link;
                                theChapter.imgUrl = chapter._embedded['wp:featuredmedia'][0]['source_url'];
                                
                                chapters.push(theChapter);
                            }

                            modules.forEach(function(module){
                                
                                if(module.acf_fc_layout == 'subtitle'){
                                    var subtitle = module.subtitle.toLowerCase();

                                    if(subtitle.includes(val)){
                                        var theChapter = {};
                
                                        theChapter.title = chapter.title.rendered;
                                        theChapter.permalink = chapter.link;
                                        theChapter.imgUrl = chapter._embedded['wp:featuredmedia'][0]['source_url'];
                                        
                                        chapters.push(theChapter);
                                    }
                                }

                                if(module.acf_fc_layout == 'text_and_media'){
                                    var text = module.text.toLowerCase();

                                    if(text.includes(val)){
                                        var theChapter = {};
                
                                        theChapter.title = chapter.title.rendered;
                                        theChapter.permalink = chapter.link;
                                        theChapter.imgUrl = chapter._embedded['wp:featuredmedia'][0]['source_url'];
                                        
                                        chapters.push(theChapter);
                                    }
                                }

                                if(module.acf_fc_layout == 'highlight'){
                                    var content = module.content.toLowerCase();

                                    if(content.includes(val)){
                                        var theChapter = {};
                
                                        theChapter.title = chapter.title.rendered;
                                        theChapter.permalink = chapter.link;
                                        theChapter.imgUrl = chapter._embedded['wp:featuredmedia'][0]['source_url'];
                                        
                                        chapters.push(theChapter);
                                    }
                                }

                                if(module.acf_fc_layout == 'focus'){
                                    var content = module.content.toLowerCase();

                                    if(content.includes(val)){
                                        var theChapter = {};
                
                                        theChapter.title = chapter.title.rendered;
                                        theChapter.permalink = chapter.link;
                                        theChapter.imgUrl = chapter._embedded['wp:featuredmedia'][0]['source_url'];
                                        
                                        chapters.push(theChapter);
                                    }
                                }
                            
                            });
                        });
                    }
                } 
                
            );
            
            //

            const uniqueIds = [];

            chapters = chapters.filter(element => {
              const isDuplicate = uniqueIds.includes(element.title);
            
              if (!isDuplicate) {
                uniqueIds.push(element.title);
            
                return true;
              }
            
              return false;
            });

            //

            if(chapters.length > 0){
                $('.search-bar__sentence').show(); 
            } else {
                $('.search-bar__sentence').hide(); 
            }
            $('.search-bar__results ul').empty();
            
            

            chapters.forEach(function(chapter){
                var el =    `<li class="one-result">
                                <a href="${chapter.permalink}" title="${chapter.title}">
                                <div class="one-result__media"><img src="${chapter.imgUrl}"></div>
                                <span class="one-result__title">${chapter.title}</span>
                                </a>
                            </li>`;
                $('.search-bar__results ul').append(el);
                $('.search-bar__results').show();
            })

            
        });
        
        
    
    }

    function slidersImg() {
        
        $('.slider-img').each(function () {
            var thisSlider = $(this).find('.slider-img__wrapper')[0];
            var thisPagination = $(this).find('.swiper-pagination')[0];

            var sliderImg = new Swiper(thisSlider, {
                // slidesPerView: 1,
                slidesPerView: 'auto',
                spaceBetween: 25,
                speed: 600,
                pagination: {
                    el: thisPagination,
                    clickable: true,
                },
                // navigation: {
                //     nextEl: '.chapter-nav__prev-next--next',
                //     prevEl: '.chapter-nav__prev-next--prev',
                // },
                // initialSlide: $('.chapter-nav__item--current').length ? $('.chapter-nav__item--current').index() : 0,
                // parallax: {
                //     enabled: true
                // },
                // breakpoints: {
                //     // when window width is >= 750px
                //     750: {
                //         slidesPerView: 2,
                //         //spaceBetween: 25
                //     },
                //     1000: {
                //         slidesPerView: 3,
                //     },
                //     1500: {
                //         slidesPerView: 4,
                //     }
                // }
            });

        });

        // sliderImg = new Swiper('.slider-img', {
        //     slidesPerView: 1,
        //     spaceBetween: 25,
        //     speed: 600
        // });
    };

    function pageNav() {
        // setTimeout(() => {
        //     var pageNavWidth = $('.page-nav').outerWidth(true);
        //     $('.page-nav-trigger').css('--page-nav-width', pageNavWidth + 'px');
        // }, 500);

        var navLinks = Array.from(document.querySelectorAll('#js-generated-nav a[href^="#"]'));
        var setActiveNavLink = function (activeLink) {
            navLinks.forEach(function (link) {
                link.classList.remove('active');
            });

            if (activeLink) {
                activeLink.classList.add('active');
            }
        };
        var updateActiveNavLinkFromScroll = function (targets) {
            var scrollPosition = window.scrollY + pageNavActivationOffsetPx;
            var activeItem = null;

            targets.forEach(function (item) {
                if (item.target.offsetTop <= scrollPosition) {
                    activeItem = item;
                }
            });

            if (activeItem) {
                setActiveNavLink(activeItem.link);
            } else if (targets.length) {
                setActiveNavLink(targets[0].link);
            }
        };

        $(document).off('click.pageNav', '.page-nav a');
        $(document).on('click.pageNav', '.page-nav a', function (e) {
            e.preventDefault();
            var clickedLink = this;
            var hash = $(this).attr('href');
            var targetId = hash ? decodeURIComponent(hash.replace('#', '')) : '';
            var target = targetId ? document.getElementById(targetId) : null;

            if (!target) {
                return;
            }

            gsap.to(window, {
                duration: 1,
                scrollTo: { y: target, offsetY: pageNavActivationOffsetPx },
                ease: Power4.easeInOut,
                onComplete: function () {
                    setActiveNavLink(clickedLink);
                }
            });
        });

        ScrollTrigger.create({
            trigger: '.main',
            start: 'top bottom',
            //endTrigger: next,
            end: 'bottom center',
            // end: () => {return '+=' + window.innerWidth * 2 + 'px'},
            invalidateOnRefresh: true,
            refreshPriority: -1000,
            //markers: true,
            //onEnter: () => {},
            // onLeaveBack: () => {
            //
            //     if (!pageNavIsClosed) {
            //         togglePageNav('close');
            //     }
            // },
            // onLeave: () => {
            //
            //     if (!pageNavIsClosed) {
            //         togglePageNav('close');
            //     }
            // },
        });

        pageNavActiveTriggers.forEach(function (trigger) {
            trigger.kill();
        });
        pageNavActiveTriggers = [];

        var navTargets = navLinks.map(function (link) {
            var hash = link.getAttribute('href');
            if (!hash) {
                return null;
            }

            var targetId = decodeURIComponent(hash.replace('#', ''));
            var target = targetId ? document.getElementById(targetId) : null;
            if (!target) {
                return null;
            }

            return { link: link, target: target };
        }).filter(Boolean);

        navTargets.forEach(function (item, index) {
            var nextItem = navTargets[index + 1];

            pageNavActiveTriggers.push(ScrollTrigger.create({
                trigger: item.target,
                start: function () {
                    return 'top+=' + pageNavScrollTriggerThreshold + ' top';
                },
                endTrigger: nextItem ? nextItem.target : '.main',
                end: function () {
                    return nextItem ? 'top+=' + pageNavScrollTriggerThreshold + ' top' : 'bottom bottom';
                },
                invalidateOnRefresh: true,
                refreshPriority: -1000,
                onEnter: function () {
                    setActiveNavLink(item.link);
                },
                onEnterBack: function () {
                    setActiveNavLink(item.link);
                }
            }));
        });

        updateActiveNavLinkFromScroll(navTargets);

        $('.section').each(function () {

            var thisTitle = $(this).find('>.title').html();
            var next = $(this).next('.section');
            var previous = $(this).prev('.section');
            var previousTitle = previous.find('>.title').html();
            var breadcrumbSectionNameHtml = $('body').find('.breadcrumb__section-name span');

            ScrollTrigger.create({
                trigger: $(this),
                start: 'top 10px',
                endTrigger: next,
                end: 'top top',
                // end: () => {return '+=' + window.innerWidth * 2 + 'px'},
                invalidateOnRefresh: true,
                refreshPriority: -1000,
                // markers: true,
                onEnter: () => {
                    
                    gsap.to(breadcrumbSectionNameHtml, {
                        yPercent: -50, autoAlpha: 0, duration: .2, ease: Power1.easeInOut, onComplete() {
                            breadcrumbSectionNameHtml.html(thisTitle);
                            gsap.fromTo(breadcrumbSectionNameHtml, { yPercent: 50, autoAlpha: 0, duration: .2, ease: Power1.easeInOut }, { yPercent: 0, autoAlpha: 1 });
                        }
                    });
                },
                onLeaveBack: () => {
                    
                    gsap.to(breadcrumbSectionNameHtml, {
                        yPercent: 50, autoAlpha: 0, duration: .2, ease: Power1.easeInOut, onComplete() {
                            if (previousTitle) {
                                breadcrumbSectionNameHtml.html(previousTitle);
                            } else {
                                breadcrumbSectionNameHtml.empty();
                            }


                            gsap.fromTo(breadcrumbSectionNameHtml, { yPercent: -50, autoAlpha: 0, duration: .2, ease: Power1.easeInOut }, { yPercent: 0, autoAlpha: 1 });
                        }
                    });
                }
            });
        });

    }

    function dropdowns() {
        $('.dropdown__trigger').on('click', function () {
            //
            var thisDropdown = $(this).parent('.dropdown');
            var isOpen = thisDropdown.hasClass('dropdown--is-open');
            var dropdownContent = thisDropdown.find('.dropdown__content');
            var dropdownContentHeight = dropdownContent.find('>div').outerHeight(true);

            if (!isOpen) {
                gsap.to(dropdownContent, {
                    height: dropdownContentHeight, duration: .75,
                    onStart: function () {
                        thisDropdown.addClass('dropdown--is-open');
                    },
                    onComplete: function () {
                        dropdownContent.css('height', 'auto');
                        ScrollTrigger.refresh();
                    }
                });
            } else {
                gsap.to(dropdownContent, {
                    height: 0, duration: .75, onComplete: function () {
                        thisDropdown.removeClass('dropdown--is-open');
                        ScrollTrigger.refresh();
                    }
                });
            }
        });
    };

    function masonry() {
        var $grid = $('.masonry').imagesLoaded(function () {
            $grid.masonry({
                itemSelector: '.masonry__item',
                percentPosition: true,
                columnWidth: '.masonry__grid-sizer',
                transitionDuration: 0
            });
        });
    };

    function plyrVid(){
        $('.video__video').each(function(){
            var player = new Plyr($(this));
        });
        
    };

    function colorMainNavLink() {
        $('.main-nav__level--2 a').on('mouseover mousenter focus', function (e) {
            $(this).parents('.main-nav__level').prev().addClass('active');
        });

        $('.main-nav__level--2 a').on('mouseleave blur', function (e) {
            $(this).parents('.main-nav__level').prev().removeClass('active');
        });
    };

    function toggleMainNav(toggle) {
        if (toggle == 'close') {
            $('.main-nav').addClass('main-nav--is-closed');
            $('body').removeClass('nav-is-open');
            //$('.chapter-nav-trigger').addClass('chapter-nav-trigger--close');
            $('.main-nav-trigger').addClass('main-nav-trigger--close').removeClass('main-nav-trigger--open');
            topBarLeft[0].style.opacity = 100;
            topBar.style.background = 'var(--top-navigation-background-color)';
            mainNavIsClosed = true;
        } else {
            $('.main-nav').removeClass('main-nav--is-closed');
            $('body').addClass('nav-is-open');
            //$('.chapter-nav-trigger').addClass('chapter-nav-trigger--open');
            $('.main-nav-trigger').removeClass('main-nav-trigger--close').addClass('main-nav-trigger--open');
            topBarLeft[0].style.opacity = 0;
            topBar.style.background = 'transparent';
            mainNavIsClosed = false;
        }
    }

    function toggleChapterNav(toggle) {
        if (toggle == 'close') {
            $('.chapter-nav').addClass('chapter-nav--is-closed');
            $('.chapter-nav-trigger').addClass('chapter-nav-trigger--close').removeClass('chapter-nav-trigger--open');
            topBarLeft[0].style.opacity = 100;
            topBar.style.background = 'var(--top-navigation-background-color)';
            chapterNavIsClosed = true;
        } else {
            $('.chapter-nav').removeClass('chapter-nav--is-closed');
            $('.chapter-nav-trigger').addClass('chapter-nav-trigger--open').removeClass('chapter-nav-trigger--close');
            topBarLeft[0].style.opacity = 0;
            topBar.style.background = 'transparent';
            chapterNavIsClosed = false;
        }
    }
    
    // function togglePageNav(toggle) {
    //     if (toggle == 'close') {
    //
    //         $('.page-nav').addClass('page-nav--is-closed');
    //         $('.page-nav-trigger').removeClass('page-nav-trigger--close');
    //         // $('body').removeClass('page-nav-is-open');
    //         pageNavIsClosed = true;
    //     } else {
    //
    //         $('.page-nav').removeClass('page-nav--is-closed');
    //         $('.page-nav-trigger').addClass('page-nav-trigger--close');
    //         // $('body').addClass('page-nav-is-open');
    //         pageNavIsClosed = false;
    //     }
    // }
    
    function toggleSearchBar(toggle) {
        if (toggle == 'close') {
            
            $('.search-bar').addClass('search-bar--is-closed');
            //$('.page-nav-trigger').removeClass('page-nav-trigger--close');
            // $('body').removeClass('page-nav-is-open');
            topBarLeft[0].style.opacity = 100;
            topBar.style.background = 'var(--top-navigation-background-color)';
            searchBarIsClosed = true;
        } else {
            
            $('.search-bar').removeClass('search-bar--is-closed');
            //$('.page-nav-trigger').addClass('page-nav-trigger--close');
            // $('body').addClass('page-nav-is-open');
            topBarLeft[0].style.opacity = 0;
            topBar.style.background = 'transparent';
            searchBarIsClosed = false;
        }
    }

    function chapterNavSlider() {

        chapterSlider = new Swiper('.chapter-nav__slider', {
            slidesPerView: 1,
            spaceBetween: 25,
            speed: 600,
            navigation: {
                nextEl: '.chapter-nav__prev-next--next',
                prevEl: '.chapter-nav__prev-next--prev',
            },
            initialSlide: $('.chapter-nav__item--current').length ? $('.chapter-nav__item--current').index() : 0,
            parallax: {
                enabled: true
            },
            breakpoints: {
                // when window width is >= 750px
                750: {
                    slidesPerView: 2,
                    //spaceBetween: 25
                },
                1000: {
                    slidesPerView: 3,
                },
                1500: {
                    slidesPerView: 4,
                }
            }
        });
    };

    function scrollToHeader() {
        $('.scroll-to').on('click', function (e) {
            e.preventDefault();
            var windowPosition = window.innerHeight / 3 * 2;
            gsap.to(window, { duration: 1, scrollTo: { y: windowPosition }, ease: Power4.easeInOut });
        });
    };

    function hideScrollTo(scrollTo, header) {
        gsap.to(scrollTo, {
            scrollTrigger: {
                trigger: header,
                start: 'top top',
                end: 'bottom center',
                scrub: true,
                //markers: true
            },
            yPercent: -100,
            autoAlpha: 0
        });
    }

});